import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Bg from "../assets/images/bgt.png"
import NavbarComponent from "./home/NavbarComponent"
import Footer from "./home/Footer"

class NonAuthLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.capitalizeFirstLetter.bind(this)
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  // componentDidMount() {
  //   let currentage = this.capitalizeFirstLetter(this.props.location.pathname)

  //   document.title =
  //     currentage + " | Veltrix - Responsive Bootstrap 5 Admin Dashboard"
  // }
  render() {
    return <React.Fragment>
      <div className="" style={{
        backgroundImage: `url(${Bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "50vh"
      }}>
        <div className="d-flex  flex-column flex-shrink  justify-content-between min-vh-100">
          <div className="">
            <div className="d-flex justify-content-between flex-column min-vh-100 ">
              <NavbarComponent/>
              <main>
                {this.props.children}
              </main>
            </div>
          </div>
          <Footer/>

        </div>

      </div>

    </React.Fragment>
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
}

export default withRouter(NonAuthLayout)
